import * as t from 'io-ts';

export const useTradingAgency = t.union([
  t.literal('UNUSED'),
  t.literal('USED'),
  t.literal('UNKNOWN'),
]);

export type UseTradingAgency = t.TypeOf<typeof useTradingAgency>;
